import { CuisineListing } from 'components/cards/cuisine-listing';
import { DynamicImage } from 'components/dynamic-image';
import { StarRating } from 'components/flair/star-rating';
import { WavyEdge } from 'components/flair/WavyEdge';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getFrontEndUrl } from 'utils/environment-util';
import { CityPageShefFragment } from 'utils/gqlReactTypings.generated.d';

const IMAGE_SIZE = 88;
interface IProps {
  className?: string;
  shef: CityPageShefFragment;
}

export const ShefCard: React.FC<IProps> = ({ className, shef }) => {
  const href = `${getFrontEndUrl()}/order/shef/${shef.id}`;

  if (!shef.imageUrl) return null;

  const displayName = `Shef ${shef?.publicName}`;

  return (
    <NoFollowLink
      href={href}
      key={shef.id}
      className={`flex h-[514px] w-[328px] min-w-[330px] cursor-pointer flex-col
                  items-start rounded-[8px] border border-neutral-50 bg-white ${className}`}>
      {/* Shef Header */}
      <div className='relative flex w-full flex-col items-center bg-jackfruit-25 p-4 pb-8'>
        <div className='mb-4'>
          <DynamicImage
            className='rounded-full'
            src={shef.imageUrl}
            alt={displayName}
            width={IMAGE_SIZE}
            height={IMAGE_SIZE}
            sourceWidth={IMAGE_SIZE}
            sourceHeight={IMAGE_SIZE}
            effect={'opacity'}
          />
        </div>
        <span className='mb-1 text-lg font-bold text-neutral-800'>{displayName}</span>
        <CuisineListing className='mb-2 text-center' formattedCuisineCategories={shef.formattedCuisineCategories} />

        {(shef.rating?.score ?? 0) >= 3 && <StarRating className='mb-4' rating={shef.rating?.score} />}

        <div className='flex flex-row gap-2 text-xs font-semibold'>
          {shef.rating?.count ? (
            <div className='flex flex-row items-center gap-2 rounded bg-white px-2 py-1 text-neutral-800'>
              <i className='fas fa-comment' />
              <span>{shef.rating?.count} reviews</span>
            </div>
          ) : null}
        </div>
        <WavyEdge amplitude={32} frequency={32} />
      </div>

      {/* Shef Content */}
      <div className='flex w-full grow flex-col overflow-hidden text-ellipsis p-6'>
        <span className='line-clamp-[7] text-base font-medium text-neutral-700'>{shef.bio}</span>
      </div>

      {/* Shef Footer */}
      <div className='flex w-full flex-row items-center justify-center pb-6'>
        <span className='text-sm font-semibold text-neutral-800'>Explore {displayName}'s menu</span>
        <i className='far fa-chevron-right ml-2 text-xs' />
      </div>
    </NoFollowLink>
  );
};
